import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import GymMap from '~/javascript/components/admin/gyms/gym_map.vue'

export default class extends Controller {
  static values = {
    mapboxToken: String
  }

  connect() {
    const props = {
      mapboxToken: this.mapboxTokenValue
    }

    this.vue = createApp(GymMap, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
